.button {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 426px;
  height: unset;
  padding: 13px 20px;
  font-size: var(--font-size-sm);
  color: var(--color-white);
  word-break: break-all;
  cursor: pointer;
  background-color: var(--color-primary-blue-700);
  border-color: var(--color-gray-300);
  border-width: 1px;
  border-radius: 3px;

  @media screen and (width >= 769px) {
    font-size: var(--font-size-md);
  }
}
